import adminEmployee from './admin.employee';
import shopadmin from './shopadmin';
import admin from './admin';

function isLocalDev() {
  return window.location.host.indexOf('localhost') > -1 && window.localStorage.getItem('local_dev');
}
function isShopAdmin() {
  return window.location.href.indexOf('shopadmin') !== -1
}
function getLoginType() {
  let login_type = '';
  try {
    const presist = window.localStorage.getItem('__presist');
    login_type = JSON.parse(presist)?.user?.login_type;
  } catch (e) {
    console.log(e);
  }
  return login_type;
}

export function getAdminMenu() {
  if(isLocalDev()) {
    let res = null;
    if (isShopAdmin()) {
      // 店铺管理后台
      res = {
        data: shopadmin
      };
    } else {
      // 平台管理后台
      res = {
        // data: getLoginType() === 'admin' ? admin : adminEmployee
        data: adminEmployee
      };
    }
    console.log('res============', res);
    return res;
  }
  return false;
}

export function setAdminMenu(commit) {
  if(isLocalDev()) {
    if (isShopAdmin()) {
      // 店铺管理后台
      if (shopadmin && typeof shopadmin.data) {
        try {
          commit('SET_MENU', { menus: shopadmin.data });
        } catch (error) {
          console.log(error);
        }
        try {
          console.log('shopadmin=====router====', shopadmin.data[0].children[0].url);
        } catch (error) {
          console.log(error);
        }
      }
    } else {
      // 平台管理后台
      if (adminEmployee && typeof adminEmployee.data) {
        try {
          commit('SET_MENU', { menus: adminEmployee.data });
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
}